export const HomeTranslations = {
  homePageTranslations: {
    sections: {
      caregiverStories: {
        title: 'Caregiver Stories',
        description: 'Our caregiver bloggers share their stories about caring for friends and family and life after caregiving.'
      }
    }
  }
}